module.exports = __webpack_public_path__ + "static/img/79-1.08852fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/79-1.jpg
// module id = qZHO
// module chunks = 0